import { MoyenPaiement } from 'app/shared/model/facture.model';

export const getPaymentMethod = (method: MoyenPaiement) => {
  switch (method) {
    case MoyenPaiement.WAVE:
      return method;
    case MoyenPaiement.OM:
      return 'ORANGE-MONEY';
    case MoyenPaiement.ESPECE_CHECK:
      return 'Espèces/Chèque';
    default:
      return 'En Attente';
  }
};

export const getPaymentMethodFromString = (method: string) => {
  switch (method) {
    case 'WAVE':
      return 'Wave';
    case 'OM':
      return 'ORANGE-MONEY';
    case 'ESPECE_CHECK':
      return 'Espèces/Chèque';
    default:
      return method;
  }
};
